import React from 'react';
import { tv } from 'tailwind-variants';

interface SectionCardHeaderProps {
  title: string;
}

export const SectionCardHeader: React.FC<SectionCardHeaderProps> = ({ title }) => {
  const { header } = TAILWIND_VARIANTS();
  return <h4 className={header()}>{title}</h4>;
};

const TAILWIND_VARIANTS = tv({
  slots: {
    header: [
      'font-typography-font-family-body',
      'text-typography-font-size-small',
      'font-semibold',
      'leading-typography-line-height-small',
      'text-component-section-body',
    ],
  },
});
